/**
 * Weather condition node definition.
 */

import type { NodeDefinition } from '../types';
import type { FlowNode } from '../../../types/flow-types';
import { createWeatherConditionFromFlow } from '../../../converters/helpers/weather-conditions';

export const weatherConditionDefinition: NodeDefinition = {
	type: 'weatherCondition',
	category: 'condition',
	sourceHandles: ['true', 'false'],

	defaultData: () => ({
		label: 'Weather Condition',
		weatherCond: 'temperature',
		operator: 'equal',
		value: '',
		executionType: 'once',
		hourOffset: 0,
		locid: '',
	}),

	toSceneJson: (node: FlowNode) => {
		if (node.data.sceneData) {
			const sceneData = { ...(node.data.sceneData as any) };
			sceneData._fid = sceneData._fid || node.id;
			return sceneData;
		}
		if (node.data.originalCondition) {
			const original = { ...(node.data.originalCondition as any) };
			original._fid = original._fid || node.id;
			return original;
		}

		const result = createWeatherConditionFromFlow({
			cond: (node.data.weatherCond as string) || 'temperature',
			op: (node.data.operator as string) || 'equal',
			value: node.data.value ?? 0,
			locid: (node.data.locid as string) || '',
			hours: Number(node.data.hourOffset ?? 0),
			execution_type: (node.data.executionType as 'once' | 'any') || 'once',
		});
		if (!result) return null;
		return { ...result, _fid: node.id };
	},
};
